import { render, staticRenderFns } from "./CreateChain.vue?vue&type=template&id=63d6c644&scoped=true&"
import script from "./CreateChain.vue?vue&type=script&lang=ts&"
export * from "./CreateChain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d6c644",
  null
  
)

export default component.exports